import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

declare global {
  interface Window {
    Pusher: typeof Pusher;
  }
}

// Reverb usa el protocolo Pusher — pusher-js debe estar en window
window.Pusher = Pusher;

const API_URL      = import.meta.env.SX_VITE_API_URL          ?? 'http://api.app.test';
const APP_TOKEN    = import.meta.env.SX_VITE_APP_TOKEN         ?? '';
const REVERB_KEY   = import.meta.env.SX_VITE_REVERB_APP_KEY   ?? '';
const REVERB_HOST  = import.meta.env.SX_VITE_REVERB_HOST      ?? 'localhost';
const REVERB_PORT  = parseInt(import.meta.env.SX_VITE_REVERB_PORT ?? '8080', 10);
const REVERB_TLS   = (import.meta.env.SX_VITE_REVERB_SCHEME   ?? 'http') === 'https';

let echo: Echo<any> | null = null;

/**
 * Crea (o recrea) la conexión Echo/Reverb con el JWT del usuario autenticado.
 * Llamar una vez después del login exitoso.
 */
export function createEcho(jwtToken: string): Echo<any> {
  if (echo) {
    echo.disconnect();
    echo = null;
  }

  echo = new Echo({
    broadcaster:        'reverb',
    key:                REVERB_KEY,
    wsHost:             REVERB_HOST,
    wsPort:             REVERB_PORT,
    wssPort:            REVERB_PORT,
    forceTLS:           REVERB_TLS,
    enabledTransports:  REVERB_TLS ? ['wss'] : ['ws'],
    // Endpoint que autentica canales privados — usa check.token + auth:api_web
    authEndpoint:       `${API_URL}/api/web/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        Token:         APP_TOKEN,
      },
    },
  });

  return echo;
}

export function getEcho(): Echo<any> | null {
  return echo;
}

export function destroyEcho(): void {
  echo?.disconnect();
  echo = null;
}
